module.exports = __webpack_public_path__ + "img/Swish.e3540dbc.png";